import { defineComponent as _defineComponent } from 'vue'
export interface Props extends BFormInput.Props {
  value?: number | string | null;
  querier: Querier;
  /** ... */
  fieldId?: string;
  placeholder?: string;
  clearable?: boolean;
}

/** `FormQuerySelect` component emits. */
export type Emits = (event: 'input', value: number | string | null) => void;


import { ref, computed, watch, watchEffect, defineComponent } from 'vue';
import { BFormInput } from 'bootstrap-vue';
import uniqueId from 'lodash/uniqueId';

import { useEventListener } from '@composables';
import { ls } from '@services/ls';

export interface ResultItem {
  text: string;
  value: string | number;
}

export type Querier = (queryText: string) => Promise<ResultItem[]>;

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    FormQuerySelect: ComponentWithProps<Props>;
  }
}

const FIELD_ID_PREFIX = `form-query-field`;

const __default__ = defineComponent({ name: 'FormQuerySelect' });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: { default: null },
    querier: null,
    fieldId: { default: '' },
    placeholder: { default: '' },
    clearable: { type: Boolean, default: true }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((event: 'input', value: number | string | null) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number | string | null, querier: Querier, fieldId: string, placeholder: string, clearable: boolean };

/**
 * `FormQuerySelect` component properties.
 */




const queryField = ref<BFormInput | null>(null);

const popoverShow = ref(false);
const loading = ref(false);
const queryText = ref<string | null>(null);
const selectedResult = ref<ResultItem | null>(null);
const results = ref<ResultItem[]>([]);

const elemId = ref('');

watchEffect(() => {
  const id = props.fieldId || uniqueId();

  if (props.fieldId) {
    // Attempt to get cached result item value.
    const data = ls.getObject(props.fieldId) as ResultItem | null;

    if (data && props.value && data.value === props.value) {
      selectedResult.value = data;
    }
  }

  elemId.value = `${FIELD_ID_PREFIX}-${id}`;
});

// Close the popup if the user clicks outside its element.
useEventListener('click', ({ target }) => {
  if (!popoverShow.value || !target) return;

  const elem = document.querySelector(
    `[data-form-query-select-id="${elemId.value}"]`,
  );

  if (!elem) return;

  if (elem !== target && !elem.contains(target as Node)) {
    popoverShow.value = false;
  }
});

const displayValue = computed(() => {
  let value;

  if (props.value !== null) {
    value = selectedResult.value?.text ?? '';
  } else {
    value = props.placeholder ?? 'Select an option';
  }

  return value;
});

watch(queryText, async (value) => {
  let items: ResultItem[] = [];

  if (value !== null) {
    loading.value = true;

    try {
      items = await props.querier(value);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }

    loading.value = false;
  }

  results.value = items;
});

watch(popoverShow, (value) => {
  if (value) {
    window.setTimeout(() => {
      queryField.value?.focus();
    }, 1);
  } else {
    // queryText.value = null;
  }
});

function setValue(value: number | string | null) {
  emit('input', value);

  selectedResult.value =
    results.value.find((item) => item.value === value) ?? null;

  if (props.fieldId) {
    ls.setObject(props.fieldId, selectedResult.value);
  }

  popoverShow.value = false;
}

function clearValue() {
  setValue(null);
}

function clearQueryText() {
  queryText.value = null;
}

function close() {
  popoverShow.value = false;
}

return { __sfc: true,FIELD_ID_PREFIX, props, emit, queryField, popoverShow, loading, queryText, selectedResult, results, elemId, displayValue, setValue, clearValue, clearQueryText, close, BFormInput }
}

})